<template>
  <div class="content">
    <div class="columns">
      <div class="column">
        <p><i class="fa fa-phone"></i> {{ $t("phone") }}</p>
        <p>
          <i class="fa fa-envelope"></i> {{ $t("lastname") }}.{{
            $t("firstname")
          }}(at)gmail.com
        </p>
        <p>
          <a href="https://github.com/RLXi"
            ><i class="fa fa-github"></i> Github</a
          >
        </p>
        <p>
          <a href="https://www.linkedin.com/in/hynale/"
            ><i class="fa fa-linkedin-square"></i> LinkedIn</a
          >
        </p>
      </div>
      <div class="column">
        <figure class="image image-custom is-256x256 pull-right">
          <img :src="getImage" alt="face" class="is-rounded" />
          <figcaption>2012 &copy; Aleksi Hynönen</figcaption>
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import { i18nMixin } from "@/vue/mixins/i18nMixin";

export default {
  mixins: [i18nMixin],
  name: "contact",
  computed: {
    getImage() {
      let image = undefined;
      try {
        image = require("@/assets/face.jpg");
      } catch (e) {
        console.log(`${image} not found`);
      }
      return image || "https://bulma.io/images/placeholders/256x256.png";
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  margin-inline: 10px;
}
</style>

<i18n>
{
    "en": {
        "pageTitle": "Contact information",
        "firstname": "forename",
        "lastname": "surname",
        "phone": "Send a message"
    },
    "fi": {
        "pageTitle": "Yhteystiedot",
        "firstname": "etunimi",
        "lastname": "sukunimi",
        "phone": "Lähetä viesti"
    }
}
</i18n>
